import en from './en.mjs'

export default Object.freeze({
  ...en,
  'common.language.label': 'Lingua',
  'common.download.action': 'Scarica',
  'common.store.appleprefix': 'Scarica su',
  'common.store.googleprefix': 'DISPONIBILE SU',
  'seo.home.title': 'Happy Pets | Compagno IA, test e widget',
  'seo.home.description': 'Scopri un animale virtuale con IA per riflettere, esplorare la personalità, consultare tarocchi e sogni, usare widget e crescerlo con gli amici.',
  'seo.home.keywords': 'Happy Pets, compagno IA, animale virtuale, widget, test personalità, MBTI, tarocchi IA',
  'seo.invite.title': 'Invito Happy Pets | Cresci un animale con gli amici',
  'seo.invite.description': 'Apri il tuo invito Happy Pets per adottare o crescere un animale virtuale con gli amici su iPhone e Android.',
  'nav.skills.label': 'Abilità',
  'nav.tests.label': 'Test',
  'nav.guidance.label': 'Guida IA',
  'nav.features.label': 'Funzioni',
  'nav.experience.label': 'Esperienza',
  'nav.community.label': 'Community',
  'nav.news.label': 'Notizie',
  'home.hero.titlelead': 'Un piccolo animale,',
  'home.hero.titleaccent': 'un piccolo aiuto ogni giorno',
  'home.hero.subtitle': 'Adotta un accogliente animale virtuale che vive sullo schermo, cresce con te e impara abilità utili per aiutarti, divertirti e farti compagnia.',
  'home.tools.eyebrow': 'Abilità del tuo animale',
  'home.tools.title': 'Piccole attività quotidiane in cui può aiutarti',
  'home.tools.description': 'Trasforma il tuo animale in un compagno utile per riflettere, trovare idee per i pasti, conoscerti meglio e prendere decisioni.',
  'home.tools.action': 'Prova ora',
  'tool.tarot.tag': 'Riflessione',
  'tool.tarot.title': 'Tarocchi',
  'tool.tarot.description': 'Lascia che il tuo animale estragga una carta e ti aiuti a vedere la domanda da un’altra prospettiva.',
  'tool.mbti.tag': 'Personalità',
  'tool.mbti.title': 'MBTI',
  'tool.mbti.description': 'Esplora il tuo tipo, confronta gli schemi e scopri come pensi e crei legami.',
  'tool.chef.tag': 'Cucina',
  'tool.chef.title': 'Chef del frigo',
  'tool.chef.description': 'Trasforma ciò che hai già in frigo in pasti semplici con il tuo piccolo chef.',
  'tool.fortune.tag': 'Quotidiano',
  'tool.fortune.title': 'Fortuna del giorno',
  'tool.fortune.description': 'Inizia la giornata con uno sguardo leggero a umore, fortuna e piccoli momenti in arrivo.',
  'tool.calorie.tag': 'Salute',
  'tool.calorie.title': 'Calcolatore di calorie',
  'tool.calorie.description': 'Stima le calorie, riconosci gli schemi nutrizionali e scegli i pasti con meno dubbi.',
  'tool.dream.tag': 'Sogni',
  'tool.dream.title': 'Interpretazione dei sogni',
  'tool.dream.description': 'Organizza i simboli della notte e trasforma frammenti confusi in temi su cui riflettere.',
  'home.assessments.eyebrow': 'Conosci meglio te stesso',
  'home.assessments.title': 'Test di scoperta di sé con risultati da esplorare',
  'home.assessments.description': 'Fai un test di personalità, ragionamento, carriera o relazioni e porta il risultato nelle conversazioni con il tuo compagno IA.',
  'home.assessments.action': 'Inizia il test',
  'home.assessments.disclaimer': 'Questi test servono per scoperta di sé e intrattenimento. Non sostituiscono diagnosi mediche o consigli professionali.',
  'assessment.mbti.eyebrow': 'Personalità',
  'assessment.mbti.title': 'Test della personalità MBTI',
  'assessment.mbti.description': 'Esplora preferenze, stile di comunicazione, punti di forza e schemi di crescita.',
  'assessment.mbti.meta': '108 domande',
  'assessment.sbti.eyebrow': 'Stile sociale',
  'assessment.sbti.title': 'Test della personalità SBTI',
  'assessment.sbti.description': 'Scopri come ti presenti agli altri attraverso cinque dimensioni di emozione, azione ed energia sociale.',
  'assessment.sbti.meta': '62 domande',
  'assessment.iq.eyebrow': 'Ragionamento',
  'assessment.iq.title': 'Valutazione del ragionamento IQ',
  'assessment.iq.description': 'Risolvi schemi non verbali e confronta diverse aree del ragionamento.',
  'assessment.iq.meta': 'Ragionamento visivo',
  'assessment.holland.eyebrow': 'Carriera',
  'assessment.holland.title': 'Interessi professionali Holland',
  'assessment.holland.description': 'Individua attività e ambienti di lavoro che possono risultarti naturali in sei aree di interesse.',
  'assessment.holland.meta': 'Interessi professionali',
  'assessment.attachment.eyebrow': 'Relazioni',
  'assessment.attachment.title': 'Test dello stile di attaccamento',
  'assessment.attachment.description': 'Rifletti su vicinanza, fiducia, sicurezza e indipendenza per comprendere meglio le tue relazioni.',
  'assessment.attachment.meta': 'Prospettiva relazionale',
  'home.guidance.eyebrow': 'Un delicato rituale quotidiano',
  'home.guidance.title': 'Guida mistica con IA fondata sulla riflessione',
  'home.guidance.description': 'Tarocchi, fortuna quotidiana e simboli dei sogni ti aiutano a rallentare, dare un nome alle emozioni e trovare un prossimo passo gestibile. Non cercano certezze sul futuro, ma più chiarezza e calma.',
  'guidance.tarot.title': 'Tarocchi IA',
  'guidance.tarot.description': 'Scegli le carte attorno a una domanda e usa la lettura come invito gentile a riflettere e cambiare prospettiva.',
  'guidance.tarot.note': 'Per riflessione e intrattenimento',
  'guidance.fortune.title': 'Fortuna del giorno',
  'guidance.fortune.description': 'Inizia la giornata osservando con leggerezza umore, energia, fortuna e incoraggiamenti pratici.',
  'guidance.fortune.note': 'Una guida nuova ogni giorno',
  'guidance.dream.title': 'Interpretazione dei sogni',
  'guidance.dream.description': 'Trasforma immagini ed emozioni dei sogni in temi da esplorare, senza considerarli previsioni certe.',
  'guidance.dream.note': 'Simboli, emozioni e riflessione',
  'home.features.eyebrow': 'Abilità utili, gioia quotidiana',
  'home.features.title': 'Perché il tuo animale diventa così utile',
  'feature.raise.title': 'Cresci animali adorabili',
  'feature.raise.description': 'Nutrili, gioca e guardali diventare compagni dolci, rassicuranti e sorprendentemente utili.',
  'feature.hatch.title': 'Fai nascere nuove abilità',
  'feature.hatch.description': 'Colleziona uova e scopri animali unici con personalità e abilità diverse.',
  'feature.coraising.title': 'Cresci con gli amici',
  'feature.coraising.description': 'Invita gli amici a prendervene cura insieme: doppio affetto, doppio divertimento.',
  'feature.status.title': 'Stato quotidiano',
  'feature.status.description': 'Tieni traccia di come stai e condividi le tue emozioni con il tuo animale.',
  'feature.frequency.title': 'Frequenza quotidiana',
  'feature.frequency.description': 'Crea eventi e segui abitudini come bere acqua, correre e altro.',
  'feature.cleaner.title': 'Pulizia foto',
  'feature.cleaner.description': 'Metti ordine nella galleria giocando. Divertente e produttivo.',
  'feature.skills.title': 'Sala abilità IA',
  'feature.skills.description': 'Sblocca nuovi look e scopri più aiuto per riflettere, pianificare e vivere il quotidiano.',
  'feature.widget.title': 'Widget interattivo',
  'feature.widget.description': 'Tieni vicino il tuo animale con i widget interattivi della schermata Home.',
  'home.steps.eyebrow': 'Per iniziare',
  'home.steps.title': 'Fai nascere un animale con abilità utili',
  'step.adopt.title': 'Adotta',
  'step.adopt.description': 'Scegli il tuo uovo unico e inizia il viaggio con un compagno tutto tuo.',
  'step.grow.title': 'Cresci',
  'step.grow.description': 'Nutrilo, gioca e interagisci ogni giorno per aiutarlo a crescere e imparare nuove abilità.',
  'step.together.title': 'Insieme',
  'step.together.description': 'Invita gli amici e lascia che i vostri animali condividano un mondo di personalità e sostegno.',
  'home.reviews.eyebrow': 'Community',
  'home.reviews.title': 'Amato per molto più della sua dolcezza',
  'home.reviews.role': 'Genitore di animale',
  'home.news.eyebrow': 'Notizie e storie',
  'home.news.title': 'Ultime notizie',
  'home.news.description': 'Idee gentili sulla vita con il tuo pet, la scoperta di sé e il benessere di ogni giorno.',
  'home.news.readarticle': 'Leggi l’articolo',
  'home.news.exploreall': 'Scopri tutte le notizie',
  'review.one.text': 'Il mio animale è adorabile, ma mi sorprende soprattutto quanto spesso uso le sue piccole abilità quotidiane.',
  'review.two.text': 'Crescerlo con il mio ragazzo ci dà tanta gioia e le abilità extra sono utili ogni giorno.',
  'review.three.text': 'I widget sono molto interattivi. Adoro avere un compagno carino che mi aiuta anche nel quotidiano.',
  'home.footer.tagline': 'Porta gioia e compagnia sulla tua schermata Home.',
  'home.footer.product': 'Prodotto',
  'home.footer.support': 'Supporto',
  'home.footer.social': 'Social',
  'home.footer.skills': 'Abilità',
  'home.footer.features': 'Funzioni',
  'home.footer.widgets': 'Widget',
  'home.footer.help': 'Centro assistenza',
  'home.footer.privacy': 'Privacy',
  'home.footer.terms': 'Termini',
  'home.footer.copyright': '© 2024 Happy Pet. Tutti i diritti riservati.',
  'home.image.logoalt': 'Logo Happy Pets',
  'home.image.screenalt': 'Schermata dell’app Happy Pets',
  'home.image.enlargedalt': 'Schermata Happy Pets ingrandita',
  'home.image.close': 'Chiudi immagine',
  'invite.headline': 'I tuoi amici ti invitano a crescere un animale insieme!',
  'invite.description': 'Accetta l’invito e l’uovo si schiuderà subito. Aggiungi il tuo animale alla schermata Home.',
  'invite.download': 'Scarica',
  'invite.loadingalt': 'Caricamento di Happy Pets',
  'invite.screensalt': 'Schermate dell’app Happy Pets'
})
